export default __webpack_public_path__ + "static/media/download_prospects.2f40f937.png";